// extracted by mini-css-extract-plugin
export default {"infoTooltip":"Info_infoTooltip__x1Skk","infoIcon":"Info_infoIcon__Sk6Ys","tooltip":"Info_tooltip__NKwjC"};